// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__ZOFmr","row":"ProcedureTreatmentSummary_row__tmJdH"};